import { jsx as l, jsxs as G, Fragment as _ } from "react/jsx-runtime";
import { c as tt } from "react/compiler-runtime";
import et from "./assets/IndoorRadio.js";
import ot from "./assets/OutdoorRadio.js";
const z = {
  xsmall: {
    base: 22,
    icon: 16,
    stroke: 1
  },
  radioTable: {
    base: 32,
    icon: 24,
    stroke: 1.25
  },
  small: {
    base: 48,
    icon: 18,
    stroke: 1.5
  },
  medium: {
    base: 64,
    icon: 24,
    stroke: 2
  },
  large: {
    base: 80,
    icon: 30,
    stroke: 2.5
  }
}, st = {
  GOOD: "#226a58",
  BAD: "#9B0505",
  WARNING: "#DB5E04",
  PARTIALLY_GOOD: "#DB5E04",
  UNKNOWN: "#9E9E9E",
  NA: "#9E9E9E",
  CBRS: "#C600CA",
  OPEN_CELL: "#00A8CA"
}, lt = (X) => {
  const t = tt(40), {
    parameters: a,
    size: M,
    type: N,
    onClick: B,
    showSector: W,
    isBorderRadio: D,
    forRadioTable: I
  } = X, f = M === void 0 ? "medium" : M, v = N === void 0 ? "outdoor" : N, C = W === void 0 ? !0 : W, k = D === void 0 ? !1 : D, o = I === void 0 ? !1 : I, e = z[f] ?? z.medium, w = st[a.health];
  let h, b, m, u, p, g, x;
  if (t[0] !== e || t[1] !== o || t[2] !== k || t[3] !== B || t[4] !== a || t[5] !== C || t[6] !== f) {
    const Y = () => {
      if (!C)
        return null;
      const r = e.base / 2, n = r / 1.4 - e.stroke - (k ? 2.3 : 0);
      if ("angle" in a) {
        const {
          angle: c,
          beamwidth: i,
          gain: s,
          channelColor: A
        } = a;
        return L(c, i, s, A || "#000000", r, n);
      }
      return a.sectors.map((c, i) => {
        const {
          angle: s,
          beamwidth: A,
          gain: O,
          channelColor: y
        } = c;
        return L(s, A, O, y, r, n, i);
      });
    }, L = (r, n, c, i, s, A, O) => {
      const y = O === void 0 ? 0 : O, H = Math.min(c || 0, 30) / 30, d = A + A * (H * 0.5), Z = r - n / 2, K = r + n / 2, P = Z * Math.PI / 180, T = K * Math.PI / 180, U = s + d * Math.sin(P), q = s - d * Math.cos(P), J = s + d * Math.sin(T), Q = s - d * Math.cos(T), V = n > 180 ? 1 : 0;
      return n === 0 || n === 360 ? /* @__PURE__ */ l("circle", { cx: s, cy: s, r: d, fill: i + "88", stroke: i, strokeWidth: e.stroke }, `sector-${y}`) : /* @__PURE__ */ l("path", { d: `M ${s} ${s} L ${U} ${q} A ${d} ${d} 0 ${V} 1 ${J} ${Q} Z`, fill: i + "66", stroke: i, strokeWidth: e.stroke }, `sector-${y}`);
    };
    let F;
    t[14] !== e.base || t[15] !== o || t[16] !== k || t[17] !== f ? (F = () => {
      if (!k)
        return null;
      const r = f === "xsmall", n = o ? r ? 0.6 : 0.8 : 1.6, c = r ? 2 : 3, i = r ? 1.25 : 2, s = o ? r ? "2, 1" : "4, 2" : "8, 4";
      return /* @__PURE__ */ G(_, { children: [
        /* @__PURE__ */ l("circle", { cx: e.base / 2, cy: e.base / 2, r: e.base / 2 - n, fill: "transparent", stroke: "#FFF", strokeWidth: c }),
        /* @__PURE__ */ l("circle", { cx: e.base / 2, cy: e.base / 2, r: e.base / 2 - n, fill: "transparent", stroke: "#000", strokeWidth: i, strokeDasharray: s })
      ] });
    }, t[14] = e.base, t[15] = o, t[16] = k, t[17] = f, t[18] = F) : F = t[18];
    const j = F;
    let S;
    t[19] !== e || t[20] !== o || t[21] !== a.network ? (S = (r) => {
      const {
        type: n
      } = r;
      return n === "indoor" ? /* @__PURE__ */ l(et, { fill: o ? "#000" : "#FFF", scale: 0.75, dimensions: e, text: a.network }) : /* @__PURE__ */ l(ot, { fill: o ? "#000" : "#FFF", scale: 1, dimensions: e, text: a.network });
    }, t[19] = e, t[20] = o, t[21] = a.network, t[22] = S) : S = t[22], h = S, u = e.base, p = e.base, g = `0 0 ${e.base} ${e.base}`, x = B, b = Y(), m = j(), t[0] = e, t[1] = o, t[2] = k, t[3] = B, t[4] = a, t[5] = C, t[6] = f, t[7] = h, t[8] = b, t[9] = m, t[10] = u, t[11] = p, t[12] = g, t[13] = x;
  } else
    h = t[7], b = t[8], m = t[9], u = t[10], p = t[11], g = t[12], x = t[13];
  let $;
  t[23] !== e.base || t[24] !== e.stroke || t[25] !== o || t[26] !== w ? ($ = !o && /* @__PURE__ */ l("circle", { cx: e.base / 2, cy: e.base / 2, r: (e.base / (o ? 1 : 1.8) - e.stroke * 2) / 2, fill: w, filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))" }), t[23] = e.base, t[24] = e.stroke, t[25] = o, t[26] = w, t[27] = $) : $ = t[27];
  let R;
  t[28] !== h || t[29] !== v ? (R = /* @__PURE__ */ l(h, { type: v }), t[28] = h, t[29] = v, t[30] = R) : R = t[30];
  let E;
  return t[31] !== b || t[32] !== m || t[33] !== $ || t[34] !== R || t[35] !== u || t[36] !== p || t[37] !== g || t[38] !== x ? (E = /* @__PURE__ */ G("svg", { width: u, height: p, viewBox: g, onClick: x, children: [
    b,
    m,
    $,
    R
  ] }), t[31] = b, t[32] = m, t[33] = $, t[34] = R, t[35] = u, t[36] = p, t[37] = g, t[38] = x, t[39] = E) : E = t[39], E;
};
export {
  lt as default
};
